import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, RadioCardButton } from 'veloe-ds';
import './ondeUsar.scss';
import ScriptTag from 'react-script-tag';

import { salvarOndeUsar } from '../../actions/pedidoActions';
import { APP_PAGES } from '../../routes';
import { ondeUsarAsync } from '../../actions/asyncActions';
import { modalAguarde, modalInformativo } from '../../Components/Modais';
import { veloeGraphQlApi } from '../../api/graphql/graphQLAPI';
import subProdutoFCG from '../../mutations/subProduto';
import { withSnackbar } from 'notistack';
import { eventTrackBasic, eventTrackRoute } from '../../utils/pushDataLayer.js';

import { modalPlanoSemMensalidade } from '../../Components/Modais';
import subProdutoTagAtiva from '../../mutations/subProdutoTagAtiva';
/**
 * Exibe as opções de uso e salva a opção do cliente
 *
 * A lista de onde usar é composta por:
 *
 *  id (inteiro)
 *  título (string com o local)
 *  texto (string com o valor)
 *
 * A váriavel botaoContinuar indica se o botão será apresentado na tela (true) ou se o click no card irá para o proximo passo (false - atual)
 * Após a escolha salva o id e o título no dicionário ondeUsar
 * */

const OndeUsar = ({
  pedido,
  history,
  salvarOndeUsar,
  activeLoader,
  inactiveLoader,
}) => {
  const { ondeUsar, codigoPromocional, dadosVeiculo } = pedido;
  const { planos } = codigoPromocional;
  const [optionsList, setOptionsList] = useState([]);
  const [pedidoOndeUsar, setPedidoOndeUsar] = useState(ondeUsar);
  const [openModalAguarde, setOpenModalAguarde] = useState(false);
  const [openModalInformativo, setOpenModalInformativo] = useState(false);
  const [textoTermos, setTextoTermos] = useState(false);
  const [botaoContinuar, setBotaoContinuar] = useState(true);

  useEffect(() => {
    const newArrayPlanosOpcoes = [planos.opcoes[3]].concat(
      planos.opcoes.slice(0, 3),
    );

    setOptionsList(newArrayPlanosOpcoes);
  }, [planos.opcoes]);

  useEffect(() => {
    const proposta = JSON.parse(localStorage.getItem('proposta'));
    if (!proposta) {
      history.push(APP_PAGES.CADASTRO);
    }

    eventTrackRoute('onde-usar');
  }, [history]);

  const ondeUsarEvent = (itemID) => {
    const novoArray = optionsList
      .filter((elemento) => elemento.id === itemID)
      .map((obj) => {
        return {
          ...obj,
          titulo: obj.titulo.replace(' e ', '/'),
        };
      });
    setPedidoOndeUsar(novoArray[0]);
    setBotaoContinuar(false);
  };

  const chamaFuncRand = async () => {
    salvarOndeUsar(pedidoOndeUsar);
    // ondeUsarAsync(this.state.ondeUsar)
    // TODO verificação dos dados assincronos
    // this.setState({openModalAguarde: true})

    eventTrackBasic('clique:botao', 'continuar');

    const { dados, tipoProduto, tagEmMaos, quantidadeI } = JSON.parse(
      localStorage.getItem('proposta'),
    );
    const reCaptcha = await window.grecaptcha.execute(
      process.env.REACT_APP_KEY_RECAPTCHA,
      {
        action: 'homepage',
      },
    );

    activeLoader();

    const { subProdutoId, subProdutoDesc } = pedidoOndeUsar;
    let payload = {
      idProposta: dados.id,
      comoUsar: 'CARRO',
      tipoProduto,
      tagEmMaos,
      quantidadeIdentificadores: quantidadeI,
      subProdutoId,
      subProdutoDesc,
      captchaResponse: reCaptcha,
    }
    let schema = subProdutoFCG
    if (pedido?.featureFlag?.enabled) {
      schema = subProdutoTagAtiva
      payload = {
        ...payload,
        placa: dadosVeiculo.placa || '',
        categoriaVeiculo: dadosVeiculo.categoriaVeiculo || '',
        categoriaEixo: dadosVeiculo.categoriaEixo || '',
      }
    }

    await veloeGraphQlApi(schema, payload)
      .then((data) => {
        const { validatorResponse } = data['subProdutoFCG'];

        if (data['subProdutoFCG'].dados) {
          const proposta = JSON.parse(localStorage.getItem('proposta'));
          localStorage.setItem(
            'proposta',
            JSON.stringify({
              ...data['subProdutoFCG'],
              ...proposta,
              subProdutoId,
              subProdutoDesc,
            }),
          );
          localStorage.setItem(
            'propostaSub',
            JSON.stringify(data['subProdutoFCG']),
          );
          inactiveLoader();
          if (tagEmMaos) {
            history.push(APP_PAGES.ONDE_RECEBER);
          } else {
            history.push(APP_PAGES.ENDERECO);
          }
        } else {
          const { errors } = validatorResponse;
          inactiveLoader();
          return errors.map((error) => {
            setTextoTermos(error.message);
            setOpenModalInformativo(true);
          });
        }
      })
      .catch((err) => {
        inactiveLoader();
        setTextoTermos(err.message);
        setOpenModalInformativo(true);
      });
  };

  const renderizaRadioButtonsOptions = () => {
    const values = optionsList.map((item) => ({
      id: item.id,
      key: `value-${item.id}`,
      value: (
        <div className="containerCard">
          <div className="containerTextCard">
            {item.subProdutoId === '001' ? (
              <span className="categoriaPlanoMobile">
                Plano sem mensalidade
              </span>
            ) : (
              <span className="categoriaPlanoMobile">
                Plano com mensalidade
              </span>
            )}
            <span className="tituloCard" data-testid={`tituloCard-${item.id}`}>
              {item.titulo}
            </span>
            {item.subProdutoId === '001' ? (
              <span className="textoCard__new">
                Recarregue e use quando quiser. <br />
                Cobrança de R$20 por tag ativa.
                {modalPlanoSemMensalidade()}
              </span>
            ) : (
              <>
                <span className="textoCard__new">
                  <strong>{item.textoDesconto}</strong>
                </span>
                <span className="textoCard__new">
                  <span>Após, a partir de </span>
                  <strong>
                    {item.valorTarifa.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                    /mês
                  </strong>
                </span>
              </>
            )}
          </div>
        </div>
      ),
    }));

    return (
      <RadioCardButton
        key="radio-cards"
        values={values}
        onBg="light"
        cardSize="lg"
        onChange={ondeUsarEvent}
        value={values.id}
      />
    );
  };

  return (
    <div className="containerComponent">
      <div className="containerText">
        <div className="containerLabel">
          <label className="areaTexto">Escolha o melhor plano pra você:</label>
        </div>
      </div>
      <div className="containerArea">
        <div className="containerOndeUsar">
          <div className="containerTextTitle">
            <div
              className="textTitlePlanoSemMensalidade"
              style={{ transform: 'translate(-100%, 275%)' }}
            >
              Planos sem mensalidade
            </div>
          </div>
          <div className="containerTextTitle">
            <div
              className="textTitlePlanoComMensalidade"
              style={{ transform: 'translate(-100%, 580%)' }}
            >
              Planos com mensalidade
            </div>
          </div>
          {renderizaRadioButtonsOptions()}

          <Button
            className="stack-button"
            {...{
              onBg: 'light',
              color: 'primary',
              disabled: botaoContinuar,
              label: 'Continuar',
              id: 'btn-continuar',
            }}
            onClick={() => chamaFuncRand()}
          />
        </div>
        {openModalInformativo &&
          modalInformativo(
            true,
            () => setOpenModalInformativo(false),
            'Ops!',
            textoTermos,
          )}
        <ScriptTag
          type="text/javascript"
          src={`https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_KEY_RECAPTCHA}`}
        />
      </div>
      {openModalAguarde && modalAguarde(true, setOpenModalAguarde(false))}
    </div>
  );
};

const mapStateToProps = ({ pedido }) => {
  return { pedido };
};

const mapDispatchToProps = (dispatch) => {
  return {
    salvarOndeUsar: (onde) => dispatch(salvarOndeUsar(onde)),
    ondeUsarAsync: (onde) => dispatch(ondeUsarAsync(onde)),
    activeLoader: () => dispatch({ type: 'loader_active' }),
    inactiveLoader: () => dispatch({ type: 'loader_inactive' }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(OndeUsar));
